// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.noWrap[data-v-a109759c] {\n  white-space: nowrap;\n}\n", ""]);
// Exports
module.exports = exports;
